import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Plus, Database, MessageCircle, Camera, Edit } from 'lucide-react';
import { useIsMobile } from '@/hooks/use-mobile';

interface ContactsHeaderProps {
  contactsCount: number;
  totalCommunications: number;
  addingSamples: boolean;
  generatingSamples: boolean;
  onAddSamples: () => void;
  onGenerateSamples: () => void;
  onAddContact: () => void;
  onScanBusinessCard?: () => void;
}

export function ContactsHeader({
  contactsCount,
  totalCommunications,
  addingSamples,
  generatingSamples,
  onAddSamples,
  onGenerateSamples,
  onAddContact,
  onScanBusinessCard,
}: ContactsHeaderProps) {
  const isMobile = useIsMobile();

  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Contacts</h1>
        <p className="text-muted-foreground">
          Manage all your business contacts in one place
        </p>
      </div>
      <div className="flex gap-2">
        {contactsCount === 0 && (
          <Button 
            variant="outline" 
            onClick={onAddSamples}
            disabled={addingSamples}
          >
            <Database className="h-4 w-4 mr-2" />
            {addingSamples ? 'Adding...' : 'Add Sample Data'}
          </Button>
        )}
        {contactsCount > 0 && totalCommunications === 0 && (
          <Button 
            variant="outline" 
            onClick={onGenerateSamples}
            disabled={generatingSamples}
          >
            <MessageCircle className="h-4 w-4 mr-2" />
            {generatingSamples ? 'Generating...' : 'Generate Sample Communications'}
          </Button>
        )}
        
        {isMobile === undefined ? (
          <Button disabled>
            <Plus className="h-4 w-4 mr-2" />
            Add Contact
          </Button>
        ) : isMobile && onScanBusinessCard ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button>
                <Plus className="h-4 w-4 mr-2" />
                Add Contact
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={onScanBusinessCard}>
                <Camera className="h-4 w-4 mr-2" />
                Scan Business Card
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onAddContact}>
                <Edit className="h-4 w-4 mr-2" />
                Manual Entry
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : isMobile ? (
          <Button onClick={onAddContact}>
            <Plus className="h-4 w-4 mr-2" />
            Add Contact
          </Button>
        ) : (
          <div className="flex gap-2">
            {onScanBusinessCard && (
              <Button variant="outline" onClick={onScanBusinessCard}>
                <Camera className="h-4 w-4 mr-2" />
                Scan Card
              </Button>
            )}
            <Button onClick={onAddContact}>
              <Plus className="h-4 w-4 mr-2" />
              Add Contact
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
